import { render, staticRenderFns } from "./BaseFiltersPrice.vue?vue&type=template&id=13c71bdc&"
import script from "./BaseFiltersPrice.vue?vue&type=script&lang=js&"
export * from "./BaseFiltersPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c71bdc')) {
      api.createRecord('13c71bdc', component.options)
    } else {
      api.reload('13c71bdc', component.options)
    }
    module.hot.accept("./BaseFiltersPrice.vue?vue&type=template&id=13c71bdc&", function () {
      api.rerender('13c71bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseFiltersPrice.vue"
export default component.exports